type WithName<T> = T & {
    name: string;
};

export type WithId<T> = T & {
    id: string;
};

export type NumberProperty = WithName<{
    type: 'number';
    number: number | null;
}>;
export type NumberPropertyResponse = WithId<NumberProperty>;

export type RelationProperty = WithName<{
    type: 'relation';
    relation: {
        id: string;
    }[];
}>;
export type RelationPropertyResponse = WithId<RelationProperty>;

export type TitleProperty = WithName<{
    type: 'title';
    text: string;
}>;
export type TitlePropertyResponse = WithId<TitleProperty>;

export type MultiselectProperty = WithName<{
    type: 'multi_select';
    multiSelect: {
        id: string;
        name: string;
    }[];
}>;
export type MultiselectPropertyResponse = WithId<MultiselectProperty>;

export type SelectProperty = WithName<{
    type: 'select';
    select: {
        id: string;
        name: string;
    } | null;
}>;
export type SelectPropertyResponse = WithId<SelectProperty>;

export type RichTextProperty = WithName<{
    type: 'rich_text';
    text: string;
}>;
export type RichTextPropertyResponse = WithId<RichTextProperty>;

export type CheckboxProperty = WithName<{
    type: 'checkbox';
    checkbox: boolean;
}>;
export type CheckboxPropertyResponse = WithId<CheckboxProperty>;

export type DateProperty = WithName<{
    type: 'date';
    date: {
        start: string;
        end: string | null;
    } | null;
}>;
export type DatePropertyResponse = WithId<DateProperty>;

type NotionHostedFile = {
    name: string;
    type: 'file';
    file: {
        url: string;
        expiryTime: string;
    };
};

type ExternalFile = {
    name: string;
    type: 'external';
    external: {
        url: string;
    };
};

export type NotionFile = NotionHostedFile | ExternalFile;

export type FilesProperty = WithName<{
    type: 'files';
    files: NotionFile[];
}>;
export type FilesPropertyResponse = WithId<FilesProperty>;

export type PageProperty =
    | NumberProperty
    | RelationProperty
    | TitleProperty
    | MultiselectProperty
    | SelectProperty
    | CheckboxProperty
    | RichTextProperty
    | DateProperty;
// Notion does not support updating files via their API, so it is omitted here

// When returned from Notion, the id will be defined
// When creating/updating a page, name is used in place of id
export type PagePropertyResponse =
    | NumberPropertyResponse
    | RelationPropertyResponse
    | TitlePropertyResponse
    | MultiselectPropertyResponse
    | SelectPropertyResponse
    | CheckboxPropertyResponse
    | RichTextPropertyResponse
    | DatePropertyResponse
    | FilesPropertyResponse;

export type PagePropertyType = PageProperty['type'];

export type PageResponse = {
    properties: PagePropertyResponse[];
    id: string;
    archived: boolean;
};

// When adding a new database here, you must also, in the AWS console,
// add the database id to the notion-secret-dev and notion-secret-prod secrets
// (the integration secret value is the same for all databases and doesn't need to be modified)
// Additionally, be sure to add the integration to the database in the Notion UI
export type DatabaseName = 'registrationCodes' | 'featureFlags' | 'featureFlagGroups' | 'organizationUsageMetrics';
